import React, { useState, useEffect } from 'react';

const COLOURS = {
  primary: '#072040',
  secondary: '#f0a500',
  success: '#91CF9B',
  white: '#ffffff',
};

const SaveScenarioModal = ({
  show,
  onClose,
  onSave,
  isSaving,
  initialClientIdentifier = '',
}) => {
  const [clientIdentifier, setClientIdentifier] = useState(initialClientIdentifier);
  const [scenarioName, setScenarioName] = useState('');

  useEffect(() => {
    if (show) {
      setClientIdentifier(initialClientIdentifier);
      setScenarioName('');
    }
  }, [show, initialClientIdentifier]);

  const handleSave = () => {
    if (!clientIdentifier.trim()) return;
    onSave(clientIdentifier.trim(), scenarioName.trim() || null);
  };

  if (!show) return null;

  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: COLOURS.primary, color: COLOURS.white }}>
            <h5 className="modal-title">
              <i className="bi bi-cloud-upload me-2"></i>
              Save Scenario to Database
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
              disabled={isSaving}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <label htmlFor="clientIdentifier" className="form-label fw-semibold">
                Client Identifier <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="clientIdentifier"
                placeholder="e.g., John Smith"
                value={clientIdentifier}
                onChange={(e) => setClientIdentifier(e.target.value)}
                autoFocus
                disabled={isSaving}
              />
              <div className="form-text">
                Used to group scenarios for the same client
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="scenarioName" className="form-label fw-semibold">
                Scenario Name <span className="text-muted">(optional)</span>
              </label>
              <input
                type="text"
                className="form-control"
                id="scenarioName"
                placeholder="e.g., Conservative scenario, 2026 Review"
                value={scenarioName}
                onChange={(e) => setScenarioName(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && clientIdentifier.trim()) handleSave();
                }}
                disabled={isSaving}
              />
              <div className="form-text">
                Optional label to distinguish this scenario from others
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={isSaving}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-retirement-primary"
              onClick={handleSave}
              disabled={!clientIdentifier.trim() || isSaving}
            >
              {isSaving ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                  Saving...
                </>
              ) : (
                <>
                  <i className="bi bi-cloud-upload me-2"></i>
                  Save Scenario
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveScenarioModal;
